import { useGetAnnouncementNonExpired } from '@announcement/announcement.queries';
import { LOCAL_STORAGE_KEYS, EVENT_NAME } from '@common/constants';
import { Badge, ComponentType } from '@gcl/react-core';
import { useState, useCallback, useEffect } from 'react';

export const AnnouncementUnreadBadge = () => {
  const [announcementUnreadCount, setAnnouncementUnreadCount] = useState(0);
  const { data: dataAnnouncementNonExpired, mutate: mutateAnnouncementNonExpired } = useGetAnnouncementNonExpired();

  const updateAnnouncementBadge = useCallback(() => {
    if (!dataAnnouncementNonExpired) {
      setAnnouncementUnreadCount(0);
      return;
    }
    const recordRead = new Set(
      (localStorage.getItem(LOCAL_STORAGE_KEYS.ANNOUNCEMENT_READ) ?? '').split(',').map((i) => Number.parseInt(i, 10)),
    );

    const unread = dataAnnouncementNonExpired?.filter((nonExpired) => !recordRead.has(nonExpired)).length ?? 0;
    setAnnouncementUnreadCount(unread);
  }, [JSON.stringify(dataAnnouncementNonExpired)]);

  useEffect(() => {
    mutateAnnouncementNonExpired();
  }, []);

  useEffect(() => {
    if (!dataAnnouncementNonExpired) return;
    updateAnnouncementBadge();
  }, [JSON.stringify(dataAnnouncementNonExpired)]);

  useEffect(() => {
    window.addEventListener(EVENT_NAME.SET_LOCAL_STORAGE, updateAnnouncementBadge);
    return () => window.removeEventListener(EVENT_NAME.SET_LOCAL_STORAGE, updateAnnouncementBadge);
  }, [updateAnnouncementBadge]);

  if (announcementUnreadCount <= 0) return <></>;
  return (
    <Badge pills type={ComponentType.Primary} className="gcl-mr-xs">
      {announcementUnreadCount}
    </Badge>
  );
};
